import { ITEMS_PER_PAGE } from '../constants';

export const getOffsetFromPage = (page: number, itemsPerPage = ITEMS_PER_PAGE): number => {
    // Ensure page is at least 1
    const safePage = Math.max(1, page);
    return (safePage - 1) * itemsPerPage;
};
